document.addEventListener("DOMContentLoaded", function (event) {
  const prevButton = document.getElementById("prev_bs");
  const nextButton = document.getElementById("next_bs");
  const sliderContainer = document.querySelector(".js-collection-bestseller");
  const sliderWidth = sliderContainer.offsetWidth;

  prevButton.addEventListener("click", function () {
    sliderContainer.scrollLeft -= sliderWidth;
  });

  nextButton.addEventListener("click", function () {
    sliderContainer.scrollLeft += sliderWidth;
  });
});